import styled from "styled-components";

export const StyledSupportCopy = styled.div`
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.rgba.black_100_50};
  font-weight: 500;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-size: ${({ theme }) =>
    theme.mixins.pxToRem(theme.figma.base.scale_1_375)};
`;

export const StyledSupportCopyText = styled.span``;
